import React, { Component } from "react";
import { SIDE_NAV_ITEMS } from "../../../api-constant";
import Sidebar from "../../Sidebar/sidebar";
import ResponsiveSidebar from "../../Sidebar/Responsive/SideBar";
import NewNavBar from "../../NavBar/Navbar";
import DownloadReports from "./DownloadReports";
import ResponsiveDownloadReports from "./Responsive/DownloadReports";
import { withRouter } from "react-router";
import addAccessTokenToUrl from "../../../Utils/Axios/addTokenToUrl";
import { reportPdfURL } from "../../../Utils/baseApi";
import axios from "axios";
import Navbar from "../../../../_components/common/Navbar";

const calcWidth = window.innerWidth;
export class Downloadreports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSideNav: SIDE_NAV_ITEMS[1].id,
      sidebarOpen: false,
      enableNotification: false,
      assessmentDetails: null,
      userId: "",
      downloadReportDropdown: [],
      devPlan: null,
      devPlanList: [],
      checkMultiRater: null,
      dataloader: null,
      collapseID: null,
    };
  }
  handleNotification = () => {
    this.setState({
      enableNotification: !this.state.enableNotification,
    });
  };
  /* handle api calls */
  componentDidMount() {
    const id = this.props.match.params.id;
    const participant__id = this.props.match.params.participant__id;
    axios
      .get(addAccessTokenToUrl("/assessments/user/active/assessments/"))
      .then((response) => {
        const id = this.props.match.params.id;
        const assessmentDetails = response.data.user_assessments.find(
          (item) => {
            return item.id == id;
          }
        );
        this.setState({
          assessmentDetails,
          checkMultiRater: assessmentDetails.instrument__is_multi_rater,
        });
      })
      .catch((error) => {
        console.error(error);
      });

    axios
      .post(addAccessTokenToUrl("/assessments/fetch/user/relation/groups/"), {
        user_assessment: id,
        user: participant__id,
        screen_type: "dashboard",
      })
      .then((response) => {
        this.setState({
          downloadReportDropdown: response.data.data.relation_list,
          devPlan: response.data.data.dev_plan,
          devPlanList: response.data.data.dev_plan_list,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  /* download 360 loi pdf handler */

  handlePdfDownload = (relationGroupName, relationId) => {
    const id = this.props.match.params.id;
    const participant__id = this.props.match.params.participant__id;
    this.setState({
      dataloader: true,
    });
    axios
      .post(addAccessTokenToUrl("/assessments/pdf/data/new/"), {
        user_assessment: id,
        user: participant__id,
        relation_group_id: relationId,
        relation_group_name: relationGroupName,
        screen_type: "",
        responseType: "blob",
        "isParticipant": true
      })
      .then((response) => {
        this.setState({
          dataloader: false,
        });
        const decoder = JSON.parse(response.data.url);
        const url = reportPdfURL + decoder.endUrl;
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "file.pdf");
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        this.setState({
          dataloader: false,
        });
      });
  };
  onSetSidebarOpen = (open) => {
    this.setState({
      sidebarOpen: open,
    });
  };

  /* download dev plan pdf handler */

  handleDevPlanDownload = (
    idUserAssessment,
    idParticipant,
    devPlanId,
    devPlan
  ) => {
    this.setState({
      dataloader: true,
    });
    axios
      .post(addAccessTokenToUrl("/assessments/development/plan/pdf/data/"), {
        user_assessment: idUserAssessment,
        user: idParticipant,
        dev_plan_id: devPlanId,
        dev_plan_name: devPlan,
        responseType: "blob",
        "isParticipant": true
      })
      .then((response) => {
        this.setState({
          dataloader: false,
        });
        const decoder = JSON.parse(response.data.url);
        const url = reportPdfURL + decoder.endUrl;
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "file.pdf");
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        this.setState({
          dataloader: false,
        });
      });
  };

  handleSelfDevPlanDownload = (
    idUserAssessment,
    idParticipant,
    devPlanId,
    devPlan
  ) => {
    this.setState({
      dataloader: true,
    });
    axios
      .post(addAccessTokenToUrl("/assessments/development/self/plan/pdf/data/"), {
        user_assessment: idUserAssessment,
        user: idParticipant,
        dev_plan_id: devPlanId,
        dev_plan_name: devPlan,
        responseType: "blob",
      })
      .then((response) => {
        this.setState({
          dataloader: false,
        });
        const decoder = JSON.parse(response.data.url);
        const url = reportPdfURL + decoder.endUrl;
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "file.pdf");
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        this.setState({
          dataloader: false,
        });
      });
  }

  /* download self loi report pdf handler */
  handleSelfReportDownload = (
    idUserAssessment,
    idParticipant,
    instrumentName
  ) => {
    if (instrumentName == "VVI") {
      /* call the vvi report api */
      this.setState({
        dataloader: true,
      });
      axios
        .post(addAccessTokenToUrl("/assessments/pdf/data/vvi/"), {
          user_assessment: idUserAssessment,
          user: idParticipant,
          responseType: "blob",
        })
        .then((response) => {
          this.setState({
            dataloader: false,
          });
          const decoder = JSON.parse(response.data.url);
          const url = reportPdfURL + decoder.endUrl;
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "file.pdf");
          link.setAttribute("target", "_blank");
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          this.setState({
            dataloader: false,
          });
        });
    } else {
      /* call the self loi report api */
      this.setState({
        dataloader: true,
      });
      axios
        .post(addAccessTokenToUrl("/assessments/pdf/data/new/"), {
          user_assessment: idUserAssessment,
          user: idParticipant,
          responseType: "blob",
          "relation_group_id": 28,
          "relation_group_name": "Self report",
          "isParticipant": true

        })
        .then((response) => {
          this.setState({
            dataloader: false,
          });
          const decoder = JSON.parse(response.data.url);
          const url = reportPdfURL + decoder.endUrl;
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "file.pdf");
          link.setAttribute("target", "_blank");
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          this.setState({
            dataloader: false,
          });
        });
    }
  };

  toggleCollapse = (collapseID) => {

    if (this.state.collapseID === collapseID) {
      this.setState({
        collapseID: null,
      });
    } else {
      this.setState({
        collapseID: collapseID,
      });
    }
  };

  render() {
    const userType = localStorage.getItem("usertype");

    return (
      <div>
        {userType.includes("organisation_admin") || userType.includes("seller_admin") ? (
          <Navbar />
        ) : (
          <NewNavBar
            enableNotification={this.state.enableNotification}
            handleNotification={this.handleNotification}
          />
        )}
        {!userType.includes("organisation_admin") && !userType.includes("seller_admin") ? (
          <ResponsiveSidebar
            items={SIDE_NAV_ITEMS}
            selectedSideNav={this.state.selectedSideNav}
            sidebarOpen={this.state.sidebarOpen}
            onSetSidebarOpen={this.onSetSidebarOpen}
          />
        ) : null}

        {!userType.includes("organisation_admin") && !userType.includes("seller_admin") ? (
          <Sidebar
            items={SIDE_NAV_ITEMS}
            selectedSideNav={this.state.selectedSideNav}
          />
        ) : null}
        {calcWidth <= 767 ? (
          <ResponsiveDownloadReports
            assessmentDetails={this.state.assessmentDetails}
            downloadReportDropdown={this.state.downloadReportDropdown}
            devPlan={this.state.devPlan}
            devPlanList={this.state.devPlanList}
            checkMultiRater={this.state.checkMultiRater}
            handlePdfDownload={this.handlePdfDownload}
            handleDevPlanDownload={this.handleDevPlanDownload}
            handleSelfDevPlanDownload={this.handleSelfDevPlanDownload}
            handleSelfReportDownload={this.handleSelfReportDownload}
            dataloader={this.state.dataloader}
            collapseID={this.state.collapseID}
            toggleCollapse={this.toggleCollapse}
          />
        ) : (
          <DownloadReports
            assessmentDetails={this.state.assessmentDetails}
            downloadReportDropdown={this.state.downloadReportDropdown}
            devPlan={this.state.devPlan}
            devPlanList={this.state.devPlanList}
            checkMultiRater={this.state.checkMultiRater}
            handlePdfDownload={this.handlePdfDownload}
            handleDevPlanDownload={this.handleDevPlanDownload}
            handleSelfDevPlanDownload={this.handleSelfDevPlanDownload}
            handleSelfReportDownload={this.handleSelfReportDownload}
            dataloader={this.state.dataloader}
          />
        )}
      </div>
    );
  }
}

export default withRouter(Downloadreports);



// WEBPACK FOOTER //
// ./src/new/Components/Reports/Download-Reports/index.jsx